import { render, staticRenderFns } from "./MaterialResources.vue?vue&type=template&id=4da4cd0a&scoped=true"
import script from "./MaterialResources.vue?vue&type=script&lang=js"
export * from "./MaterialResources.vue?vue&type=script&lang=js"
import style0 from "./MaterialResources.vue?vue&type=style&index=0&id=4da4cd0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4cd0a",
  null
  
)

export default component.exports